import React from "react";
import { useTranslation } from "react-i18next";
import { RecentlyJoinedCarousel } from "@/components/RecentlyJoinedCarousel";
import { StudentsBarChart } from "@/components/BarChart/StudentsBarChart";
import { UserRoundPlus, User, ShareIcon } from "lucide-react";
import { useCurrentCohortYear } from "@/hooks/useCurrentCohortYear";
import {
  CurrentFunnelStates,
  FunnelState,
} from "@/components/CurrentFunnelStates";
import { chartConfig } from "./config/chartConfig";
import { currentFunnelStatesDataMock } from "@/__mocks__/currentFunnelStatesDataMock";
import { i18n } from "@/i18n";
import { CommunityGrowthChart } from "@/components/CommunityGrowthChart";
import { OrganizationMetricsContextEnum } from "@/__generated__/types";
import { MetricsBentoBox } from "@/components/MetricsBentoBox";
import { useShareLink } from "@/hooks/useShareLink";

const funnelConfig = {
  title: i18n.t("adoption.currentFunnelStates.title"),
  subtitle: i18n.t("adoption.currentFunnelStates.subtitle"),
  states: currentFunnelStatesDataMock,
  getSegmentLink: (state: FunnelState) =>
    `/students?funnelState=${state.id}&cohortYear=current`,
};

export const Adoption = () => {
  const { t } = useTranslation();

  const { shareCurrentLink } = useShareLink();

  const { cohortYear } = useCurrentCohortYear();

  const studentBarChartMenu = [
    {
      label: t("global.share"),
      icon: <ShareIcon aria-hidden height={16} />,
      onClick: shareCurrentLink,
    },
  ];

  return (
    <div className="flex h-full w-full items-center justify-center">
      <div className="flex w-full flex-col gap-6 text-foreground">
        <MetricsBentoBox
          metric={OrganizationMetricsContextEnum.Adoption}
          loadingCount={4}
          showTitle={true}
          title={t("adoption.bentosAdoption.title", { cohort: cohortYear })}
          display={{
            communityMembers: {
              icon: User,
            },
            joinedInLast30Days: {
              icon: UserRoundPlus,
            },
            joinedOrganically: {
              icon: User,
            },
            communityMatched: {
              icon: User,
            },
          }}
        />
        <CurrentFunnelStates
          title={funnelConfig.title}
          subtitle={funnelConfig.subtitle}
          getSegmentLink={funnelConfig.getSegmentLink}
        />
        <CommunityGrowthChart />
        <RecentlyJoinedCarousel
          viewAllSource="Adoption - Recently Joined"
          profileSource="Adoption - New Students in Your Community"
        />
        <StudentsBarChart
          xAxisKey="funnelStep"
          title={t("adoption.chartAdoption.title")}
          description={t("adoption.chartAdoption.description")}
          menuOptions={studentBarChartMenu}
          {...{ chartConfig }}
        />
      </div>
    </div>
  );
};
